document.addEventListener('DOMContentLoaded', () => {
	read_elements();
	language_init();
})

function read_elements() {
	const changeEvent = new Event('change', {
		bubbles: true,
		cancelable: true
	});
	const load_lg = setInterval(() => {
		const default_form_lg = document.querySelector('.locale-selectors__content [action="/localization"]');

		if(default_form_lg) {

			const desktop_parent = document.querySelector('.desktop-header__tools');
			const mobile_parent = document.querySelector('.nav_footer .nav_footer_item[data-menu-language]');

			functionality_lg(desktop_parent);
			functionality_lg(mobile_parent);

			clearInterval(load_lg);

			function functionality_lg (parent) {
				if(!parent) return;
				const custom_change_event = new Event('change', {
					bubbles: true,
					cancelable: true
				});
				const select_lg_default = default_form_lg.querySelector('#country_code');
				const options_lg_default = default_form_lg.querySelectorAll('option');

				const select_btn = parent.querySelector('.select_btn');
				const lang_menu = parent.querySelector('.language_menu');
				const lang_btn_text = select_btn?.querySelector('.s_btn_text');
				const menu_items = parent.querySelector('.menu_items');

				const new_elements = Array.from(options_lg_default).map(option => {
					return `<li class="item" data-value="${option.value}">${option.textContent}</li>`
				}).join('');

				lang_btn_text.textContent = select_lg_default.value;
				menu_items.innerHTML = new_elements;

				const menu_elements = menu_items.querySelectorAll('.item');
				menu_elements.forEach(menu_item => {
					if (menu_item.dataset.value === select_lg_default.value) {
						menu_item.classList.add('active');
					}

					menu_item.addEventListener('click', () => {
						select_lg_default.value = menu_item.dataset.value;
						select_lg_default.dispatchEvent(custom_change_event)
					})
				})

				select_btn.addEventListener('mousemove', () => {
						menu_items.classList.add('show');

						const mobile_menu_container = document.querySelector('.mobile-menu-container.is-shown');
						mobile_menu_container?.classList.add('no-scroll');
						mobile_menu_container.scrollTop = 0;
				})

				if(window.innerWidth > 768) {
					menu_items.addEventListener('mouseleave', () => hidden_language_desktop());
					parent.addEventListener('mouseleave', () => hidden_language_desktop());
				}

				if(window.innerWidth <= 768) {
					document.addEventListener('click', (evt) => hidden_language_mobile(evt));
				}

				else if(window.innerWidth > 768) {
					document.removeEventListener('click', () => hidden_language_mobile());
				}

				function hidden_language_mobile(evt) {
					if(window.innerWidth > 768) {
						document.removeEventListener('click', () => hidden_language_mobile());
					}

					if(evt.target.closest('.mobile-nav-wrapper') && !evt.target.closest('.mobile-menu-container')) {
						document.querySelector('[data-burger-trigger]').click();

						setTimeout(() => {
							const mobile_menu_container = document.querySelector('.mobile-menu-container.no-scroll');
							mobile_menu_container.classList.remove('no-scroll');
							menu_items.classList.remove('show');
						}, 500)
					}
				}

				function hidden_language_desktop() {
						setTimeout(() => {
							menu_items.classList.remove('show');
						}, 50)

					if(window.innerWidth <= 768) {
						menu_items.removeEventListener('mouseleave', () => hidden_language_desktop());
						parent.removeEventListener('mouseleave', () => hidden_language_desktop());
					}
				}

				lang_menu.classList.remove('visuality-hidde');
			}
		}
	}, 1)

	setTimeout(() => {
		clearInterval(load_lg);
	}, 50000)
}


function language_init() {
	const load_language = setInterval(() => {
		const default_form_lg = document.querySelector('.locale-selectors__content [action="/localization"]');

		if(default_form_lg) {
			const select_lg_default = default_form_lg.querySelector('#country_code');
			const allElements = document.querySelectorAll('*');
			const cart_languages = Array.from(allElements).filter(element => {
				return Array.from(element.attributes).some(attr => attr.name.startsWith('data-translate-'));
			});

			const langCode = select_lg_default.value;
			const attributeUS = `data-translate-${langCode.toLowerCase()}`;
			const attributeINT = `data-translate-int`;


			cart_languages.forEach(atr => {
				if(atr.getAttribute(attributeUS)) {
					atr.textContent = atr.getAttribute(attributeUS);
				} else {
					atr.textContent = atr.getAttribute(attributeINT);
				}
			})


			clearInterval(load_language);
		}
	})
}
